import * as React from "react";

function NYSE(props: React.SVGProps<any>) {
  return (
    <svg height="1em" width="1em" viewBox="0 0 100 100" {...props}>
      <defs>
        <linearGradient
          id="XwblUMTlSL"
          spreadMethod="pad"
          gradientTransform="rotate(-90 3850.52 1558) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <linearGradient
          id="YDtBHmDTSd"
          spreadMethod="pad"
          gradientTransform="rotate(-90 3012.238 2396.282) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <linearGradient
          id="fnmrgNRfPE"
          spreadMethod="pad"
          gradientTransform="rotate(-90 3221.46 2187.06) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <linearGradient
          id="ABUvUOlBuz"
          spreadMethod="pad"
          gradientTransform="rotate(-90 2801.97 2606.55) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <linearGradient
          id="EckpSokNfZ"
          spreadMethod="pad"
          gradientTransform="rotate(-90 3432.765 1975.755) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <linearGradient
          id="PFHiNXftod"
          spreadMethod="pad"
          gradientTransform="rotate(-90 3640.26 1768.26) scale(1549.32)"
          gradientUnits="userSpaceOnUse"
          y2={0}
          x2={1}
          y1={0}
          x1={0}
        >
          <stop offset={0} stopColor="#b5e7f9" />
          <stop offset={0.1} stopColor="#a3e1f7" />
          <stop offset={0.2} stopColor="#8bdaf4" />
          <stop offset={0.3} stopColor="#6ed0f0" />
          <stop offset={0.4} stopColor="#55c7ee" />
          <stop offset={0.5} stopColor="#4cb8e6" />
          <stop offset={0.6} stopColor="#439ed6" />
          <stop offset={0.7} stopColor="#3b8ac5" />
          <stop offset={0.8} stopColor="#3475b6" />
          <stop offset={0.9} stopColor="#3063a8" />
          <stop offset={1} stopColor="#2b579e" />
        </linearGradient>
        <clipPath id="cMacfjhRLg" clipPathUnits="userSpaceOnUse">
          <path d="M40.492 3859.22h309.863v1549.32H40.492V3859.22z" />
        </clipPath>
        <clipPath id="bkZsKOdcfO" clipPathUnits="userSpaceOnUse">
          <path d="M879.477 3859.22h309.863v1549.32H879.477V3859.22z" />
        </clipPath>
        <clipPath id="AUEIviXAOk" clipPathUnits="userSpaceOnUse">
          <path d="M1717.08 3859.22h309.863v1549.32H1717.08V3859.22z" />
        </clipPath>
        <clipPath id="uYguaoSiML" clipPathUnits="userSpaceOnUse">
          <path d="M461.02 3859.22h309.875v1549.32H461.02V3859.22z" />
        </clipPath>
        <clipPath id="tItbNCwZoT" clipPathUnits="userSpaceOnUse">
          <path d="M2137.6 3859.22h309.867v1549.32H2137.6V3859.22z" />
        </clipPath>
        <clipPath id="pvoQSzONSx" clipPathUnits="userSpaceOnUse">
          <path d="M1302.08 3859.22h309.863v1549.32H1302.08V3859.22z" />
        </clipPath>
      </defs>
      <path
        d="M6.605 99.264H.936V70.66h5.67L18.17 88.849v-18.19h5.669v28.605h-5.3L6.604 80.45v18.814M27.92 70.66h6.915l6.349 10.471 6.378-10.471h7.03L44.02 86.92v12.343H38.35V86.778L27.92 70.66M72.173 78.73l2.949-4.63s-3.38-3.683-9.606-3.683c-6.317 0-9.234 4.257-9.234 8.47 0 4.223 4.069 7.039 6.817 8.122 4.209 1.484 7.184 2.214 7.184 4.334 0 1.609-1.63 2.81-3.922 2.81-4.3 0-7.703-3.512-7.703-3.512l-3.077 4.801s4.105 4.128 10.68 4.128c5.091 0 9.634-3.552 9.634-8.8 0-4.727-4.012-7.33-7.515-8.33-3.037-.886-6.243-1.735-6.243-3.882 0-1.402 1.172-2.694 3.221-2.694 3.475 0 6.815 2.866 6.815 2.866M80.98 99.264V70.66h18.593v4.994H86.65v6.81h11.11v4.995H86.65v6.81h12.924v4.995H80.98"
        fill="#100f0d"
      />
      <g clipPath="url(#cMacfjhRLg)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M40.492 3859.22h309.863v1549.32H40.492V3859.22z" fill="url(#ABUvUOlBuz)" />
      </g>
      <g clipPath="url(#uYguaoSiML)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M461.02 3859.22h309.875v1549.32H461.02V3859.22z" fill="url(#YDtBHmDTSd)" />
      </g>
      <g clipPath="url(#bkZsKOdcfO)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M879.477 3859.22h309.863v1549.32H879.477V3859.22z" fill="url(#fnmrgNRfPE)" />
      </g>
      <g clipPath="url(#pvoQSzONSx)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M1302.08 3859.22h309.863v1549.32H1302.08V3859.22z" fill="url(#EckpSokNfZ)" />
      </g>
      <g clipPath="url(#AUEIviXAOk)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M1717.08 3859.22h309.863v1549.32H1717.08V3859.22z" fill="url(#PFHiNXftod)" />
      </g>
      <g clipPath="url(#tItbNCwZoT)" transform="matrix(.04098 0 0 -.04103 -.723 222.41)">
        <path d="M2137.6 3859.22h309.867v1549.32H2137.6V3859.22z" fill="url(#XwblUMTlSL)" />
      </g>
    </svg>
  );
}

export default NYSE;
